import InterestingLots from "./interesting-lots";

export default InterestingLots